import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../api';
import { Text, Heading, Box, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Login from '../components/Login';
import Logout from '../components/Logout';
import Footer from '../components/Footer';
import Dashboard from './Dashboard';
import Operator from './Operator';
import Promoter from './Promoter';

function Cashier() {
  const [user] = useAuthState(auth);

  if (!user) return <Login />;

  if (user.displayName === 'admin') {
    return <Dashboard />;
  }

  if (user.displayName === 'operator') {
    return <Operator />;
  }

  if (user.displayName === 'promoter') {
    return <Promoter />;
  }
  
  return (
    <>
      <Heading mt={5} mb={0} color={'white'}>
        Dashboard cassa
      </Heading>
      <Text mb={3}>{process.env.REACT_APP_PROJECT_ID}</Text>
      <Box w='100%' border={'3px solid teal'} borderRadius={15} p={5} mb={10} color='white'>
        <Text fontSize={'lg'} mb={5}>
          Sei autenticato come <b>{user.email}</b>. <br />
          <br />
          In qualità di operatore cassa potrai stampare gli ordini dei clienti come una cassa classica.
        </Text>
        <Box w='100%' border={'0px solid teal'} borderRadius={15} p={5} mb={10} color='white'>
          <Text fontSize={'xl'} fontWeight={600} mb={5}>
            Cassa
          </Text>
          <Button as={Link} to='/menu'>
            Vai
          </Button>
        </Box>
      </Box>
      <Logout />
      <Footer />
    </>
  );
}
export default Cashier;
